// extracted by css-extract-rspack-plugin
export default {"commonBlock":"commonBlock-7MOKHR","commonBlockSubblocks":"commonBlockSubblocks-C2cCnI"};